import React from 'react';
import { Grid, Button, Modal, Fade, Box } from '@mui/material';
import { styled } from '@mui/system';
import { makeStyles } from '@mui/styles';
import { WarningRounded } from '@mui/icons-material';

// Styled container for the modal content
const ModalContent = styled('div')(({ theme }) => ({
  width: '95%',
  maxWidth: 450,
  padding: theme.spacing(4),
  backgroundColor: 'white',
  borderRadius: theme.shape.borderRadius,
  textAlign: 'center',
  outline: 'none',
  margin: 'auto',
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
}));

// Styles for the modal container
const useStyles = makeStyles({
  modal: {
    display: 'flex',
    alignItems: 'center',
    zIndex: '1600 !important',
    justifyContent: 'center',
    outline: 'none',
  },
});

const WeatherWarning = ({
  actionClick,
  theme,
  open = true,
}) => {
  const classes = useStyles(); 
  return (
    <Modal
      aria-labelledby="weather-warning-modal-title"
      aria-describedby="weather-warning-modal-description"
      open={open}
      className={classes.modal}>
      <Fade in={open}>
        <ModalContent>
          {/* Title with Icon */}
          <Box sx={{ marginBottom: 3 }}>
            <WarningRounded
              style={{ color: theme.primary_font_color, fontSize: '3rem' }}
            />
            <p style={{ margin: '10px 0', fontSize: '1.2rem', fontWeight: 'bold' }}>
              Order Preparation
            </p>
          </Box>
          
          {/* Content */}
          <Box sx={{ marginBottom: 3 }}>
            <p>Order will be ready in 30-40 mins - proceed ?</p>
          </Box>

          {/* Buttons */}
          <Grid container spacing={2}>
            <Grid item xs={6}>
              <Button
                onClick={() => {
                  actionClick(false);
                }}
                sx={{
                  width: '100%',
                  height: 48,
                  fontSize: 16,
                  background: theme.primary_color || theme.primaryThemeColor,
                  color: theme.secondary_font_color || theme.secondaryFontColor,
                  "&:hover": {
                    background: theme.primary_color || theme.primaryThemeColor,
                  }
                }}
                variant="contained">
                No
              </Button>
            </Grid>
            <Grid item xs={6}>
              <Button
                onClick={async () => {
                  actionClick(true);
                }}
                sx={{
                  width: '100%',
                  height: 48,
                  fontSize: 16,
                  background: theme.primary_color || theme.primaryThemeColor,
                  color: theme.secondary_font_color || theme.secondaryFontColor,
                  "&:hover": {
                    background: theme.primary_color || theme.primaryThemeColor,
                  }
                }}
                variant="contained">
                Yes
              </Button>
            </Grid>
          </Grid>
        </ModalContent>
      </Fade>
    </Modal>
  );
};

export default WeatherWarning;
